import Table from "../../components/table";

export default function GovernancePage() {
  return (
    <>
      <h2 className="text-slate-200 font-bold text-3xl mb-6">
        Governance Proxy Status
      </h2>
      <Table />
    </>
  );
}
